<template>
  <div>
    <el-select
      v-if="multiple"
      multiple
      class="select-default col-xs-12"
      @change="$emit('eventSelected', eventId)"
      name="eventId"
      size="large"
      v-model="eventId"
      placeholder="Selecione os eventos"
    >
      <el-option
        v-for="option in events"
        class="select-primary"
        :value="option.value"
        :label="option.label"
        :key="option.label"
      ></el-option>
    </el-select>
    <select
      v-else
      v-model="eventId"
      name="eventId"
      @change="$emit('eventSelected', eventId)"
      class="events-options form-control"
    >
      <option value=""> Selecione um evento...</option>
      <option
        v-for="(event, index) in events"
        :key="index"
        :value="event.value"
      > {{ event.label }}
      </option>
    </select>
    <br/>

  </div>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    name: 'events-options',
    props: {
      multiple: {
        default: false,
        type: Boolean
      },
      event: {
        default: ''
      }
    },
    data () {
      return {
        eventId: ''
      }
    },
    computed: {
      ...mapGetters('events', {
        events: 'optionsById'
      })
    },
    watch: {
      event: function () {
        this.eventId = this.event
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/EventsOptions.vue